import { render } from "./FaqsView.vue?vue&type=template&id=53ce8664&ts=true"
import script from "./FaqsView.vue?vue&type=script&lang=ts"
export * from "./FaqsView.vue?vue&type=script&lang=ts"

import "./FaqsView.vue?vue&type=style&index=0&id=53ce8664&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__